import * as constant from "../shared/constants";
import { getUserToken, needRanking, fidelityIsNational } from "../shared/utils";
import { getOffers, getRankByOfferId, updateOffer, createOffer } from "../shared/requests-api";
import { intFormat } from "../../../js/shared/utils";
import PubSub from "pubsub-js";
import "../../../js/shared/pubsub-triggers";
import { logEvent } from "../shared/firebase";

export const receiveOffers = (data, error) => ({
	type: constant.OFFERS_RECEIVED,
	data,
	error
});

export const isReloadOffers = reload => ({
	type: constant.IS_RELOAD_OFFERS,
	reload
});

export const receiveOffersByLocale = (locale, offers, error) => ({
	type: constant.RECEIVE_OFFERS_LOCALE,
	locale,
	offers,
	error
});

export const searchingOffers = () => ({
	type: constant.SEARCHING_OFFERS
});

export const receiveOfferRank = (offerId, rank) => ({
	type: constant.RECEIVE_OFFER_RANK,
	offerId,
	rank
});

export const sendingOffer = (sending, success, show) => ({
	type: constant.SENDING_OFFER,
	sending,
	success,
	show
});

export const quickSaleClean = () => {
	return function(dispatch) {
		dispatch({
			type: constant.QUICK_SALE_CLEAN
		});
	};
};

export const createOrUpdateOffer = (
	update,
	id,
	idFidelity,
	quant,
	price,
	login,
	password,
	phone,
	averageMiles,
	/*device,
	email,*/
	pwAwardSecondary,
	reductions,
	form
) => dispatch => {
	const token = getUserToken();

	dispatch(sendingOffer(true));

	let isNational = fidelityIsNational(idFidelity);
	let ranking = form.priceState ? form.priceState.rank : undefined;
	let available_cpfs = form.fidelityPrice ? form.fidelityPrice.passengersAvailable : undefined;
	let params = {
		fidelity_program_type: isNational ? "Nacional" : "Internacional",
		fidelity_select: form.fidelity.name,
		quant_miles: quant,
		price: price,
		average_miles: averageMiles || 3500,
		reductions_number: reductions,
		available_cpfs,
		ranking
	};

	if (update) {
		updateOffer(
			token,
			id,
			idFidelity,
			quant,
			price,
			login,
			password,
			phone,
			averageMiles,
			/*device,
			email,*/
			pwAwardSecondary,
			reductions,
			form.quickSale
		)
			.then(res => {
				PubSub.publish("dataLayer", {
					event: "zanoxPixelAffiliateOfferer",
					zanoxPixelAffiliateOfferer: res
				});
				logEvent("create_edit_offer", params);

				dispatch(sendingOffer(false, true, true));
				dispatch(refreshOffers());
				dispatch(isNewUser(false));
			})
			.catch(error => {
				console.log(error.response);
				dispatch(sendingOffer(false, false, true));
			});
	} else {
		createOffer(
			token,
			id,
			quant,
			price,
			login,
			password,
			phone,
			averageMiles,
			/*device,
			email,*/
			pwAwardSecondary,
			reductions,
			form.quickSale
		)
			.then(res => {
				PubSub.publish("dataLayer", {
					event: "zanoxPixelAffiliateOfferer",
					zanoxPixelAffiliateOfferer: res
				});
				logEvent("create_edit_offer", params);

				dispatch(sendingOffer(false, true, true));
				dispatch(refreshOffers());
				dispatch(isNewUser(false));
			})
			.catch(error => {
				console.log(error.response);
				dispatch(sendingOffer(false, false, true));
			});
	}
};

export const refreshOffers = () => dispatch => {
	const token = getUserToken();

	const searchRankByOffer = (dispatch, token, offerId) => {
		let self = this;
		getRankByOfferId(token, offerId)
			.then(response => {
				let rank = response.data.rank;

				if (!rank) {
					dispatch(
						receiveOfferRank(offerId, {
							position: "-",
							lastSaleDate: undefined
						})
					);
				}

				dispatch(
					receiveOfferRank(offerId, {
						position: intFormat(rank.position) + "°",
						lastSaleDate: rank.lastSaleDate
					})
				);
			})
			.catch(res => {
				dispatch(
					receiveOfferRank(offerId, {
						position: "-",
						lastSaleDate: undefined
					})
				);
			});
	};

	dispatch(searchingOffers());

	getOffers(token)
		.then(response => {
			let offers = response.data;

			if (offers && offers.offers && offers.offers.length) {
				dispatch(receiveOffers(offers));
				offers.offers.forEach(offer => {
					if (needRanking(offer)) {
						searchRankByOffer(dispatch, token, offer.id);
					}
				});
			} else {
				dispatch(receiveOffers([], "vazio"));
			}
		})
		.catch(err => {
			dispatch(receiveOffers([], err.response));
		});
};

export const editOffer = offer => ({
	type: constant.EDIT_OFFER,
	offer
});

export const showOffers = () => dispatch => {
	window.scrollTo(0, 0);
	dispatch({ type: constant.SHOW_OFFERS });
};

export const viewOffer = offer => ({
	type: constant.VIEW_OFFER,
	offer
});

export const viewRanking = id => ({
	type: constant.VIEW_RANKING,
	id
});

export const isNewUser = newUser => ({
	type: constant.IS_NEW_USER,
	newUser
});

export const saveFormOfferValues = form => ({
	type: constant.SAVE_FORM_OFFER_VALUES,
	form
});

export const receiveBanks = banks => ({
	type: constant.BANKS_RECEIVED,
	banks
});

export const receivePhoneRequiredMode = typePhoneLatam => ({
	type: constant.TYPE_PHONE_REQUIRED,
	typePhoneLatam
});

export const receiveMarketAnalysis = data => ({
	type: constant.MARKET_ANALYSIS_RECEIVED,
	data
});

export const receiveSummaryPayment = data => ({
	type: constant.SUMMARY_PAYMENT_RECEIVED,
	data
});
